const UserLevel = () =>
  import(
    /* webpackChunkName: "base-info-user-level" */ '@/pages/base-info/user/level/index.vue'
  )
const CreateUserLevel = () =>
  import(
    /* webpackChunkName: "base-info-user-level" */ '@/pages/base-info/user/level/create.vue'
  )
const EditUserLevel = () =>
  import(
    /* webpackChunkName: "base-info-user-level" */ '@/pages/base-info/user/level/edit.vue'
  )

export default {
  path: 'level',
  meta: {
    label: 'userLevel',
    auth: 'level'
  },
  component: {
    name: 'Level',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoUserLevelReport',
      path: '/',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: UserLevel
    },
    {
      name: 'BaseInfoUserCreateLevel',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateUserLevel
    },
    {
      name: 'BaseInfoUserEditLevel',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditUserLevel,
      props: true
    }
  ]
}
